export const tableColumns = [
  "" /* multigroupEdit Cbox */,
  "NOMBRE",
  "MARCA",
  "SEXO",
  "" /* functionality controllers */,
] as const;

export const subtableColumnsEsp: [
  "" /* multigroupEdit Cbox */,
  "PROMO",
  "TAMAÑO",
  "PRECIO",
  "STOCK",
  "" /* functionality controllers */
] = [
  "" /* multigroupEdit Cbox */,
  "PROMO",
  "TAMAÑO",
  "PRECIO",
  "STOCK",
  "" /* functionality controllers */,
];

export const createProdInputs = [
  { type: "text", id: "nombre", label: "Nombre producto" },
  {
    id: "sexo",
    label: "Seleccionar sexo",
    //ESTO DEBERIA SER CONST
    option: ["Femenino", "Masculino", "Unisex"] as const,
  },
  { type: "file", id: "img", label: "Cargar imagen" },
];
